module.exports = __webpack_public_path__ + "img/logo-sonic.afba3e31.png";